// See https://v2.nuxt.com/docs/configuration-glossary/configuration-router#scrollbehavior
export default function (to, from, savedPosition) {
  // Start of page name with '-' included to make sure we target child pages
  const preventScrollPages = [
    'portfolio-',
    'orders-',
    'whisky-catalogue-',
    'whisky-slug',
    'search',
  ]

  const preventScrollOnNavigation = preventScrollPages.some(
    (prefix) => to.name.startsWith(prefix) && from.name.startsWith(prefix),
  )

  if (savedPosition) {
    // Native-like behavior when navigating with back/forward buttons
    return savedPosition
  }

  // Don't scroll to top on scroll excluded pages
  if (!preventScrollOnNavigation) {
    // Scroll to top for all other route navigations
    return { x: 0, y: 0 }
  }
}
